<template>
  <div class="page-component-wrapper">
    <!-- Check Permission -->
    <template v-if="isAllowViewPage">
      <slot></slot>
    </template>
    <template v-else>
      <div class="page-component-wrapper__no-permission white-background">
        <slot name="no-permission">
          <div class="no-permission-screen">
            <img class="no-permission-screen__image" src="../../../public/img/lock.png" alt="lock">
            <h3 class="no-permission-screen__title">{{ L10n('not-enough-permission') }}</h3>
            <p class="no-permission-screen__text">{{ L10n('not-enough-permission-description') }}</p>
            <div class="no-permission-screen__controls">
              <button
                type="button"
                class="btn btn-size-s"
                @click="goToMainPage"
              >
                {{ L10n('go-to-main-page') }}
              </button>
            </div>
          </div>
        </slot>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  name: 'PageWrap',
  props: {
    permissionView: { default: null } // String
  },
  data () {
    return {
      isAllow: false
    }
  },
  computed: {
    pagePermission () {
      return this.permissionView || this.$route.meta.permission
    },
    permissions () {
      return this.$store.getters.get('permissions')
    },
    isAllowViewPage () {
      return this.permission(this.permissions, this.pagePermission)
    }
  },
  methods: {
    goToMainPage () {
      this.$router.replace({ name: 'Dashboard' })
    }
  }
}
</script>
<style lang="stylus">
.page-component-wrapper {
  flex 1

  &__no-permission {
    height 100%
    width 100%
    display flex
    align-items center
    justify-content center
  }

  &__text {
    display inline-block
    font-size 2rem
    text-transform uppercase
    text-align center
    color #ccc
    font-weight 700
  }
}

.no-permission-screen {
  display flex
  align-items center
  flex-direction column

  &__image {
    max-width 20rem
    max-height 20rem
  }

  &__title {
    color #7C8086
    text-transform capitalize
    font-weight 300
  }

  &__text {
    color #7C8086
  }
}
</style>
